import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import { devApi, prodDevApi } from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

interface IGetVirtualAccountBalanceResponse {
  status?: boolean;
  message?: string;
  statusCode?: string;
  data?: {
    totalPermanentAccountBalance: number;
    totalTransientAccountBalance: number;
    totalVirtualAccountBalance: number;
  };
}

const initialState: IApiState<IGetVirtualAccountBalanceResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getVirtualAccountBalanceAsync = createAsyncThunk(
  'virtualAccountBalance',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const devTokenInStorage = localStorage.getItem('devTokenData');

      const parsedDevTokenInStorage = devTokenInStorage
        ? JSON.parse(devTokenInStorage)
        : null;

      const developerId = localStorage.getItem('developerId');

      const environment = state.environment?.value;

      const apiInstance = environment === 'live' ? prodDevApi : devApi;

      const authToken =
        environment === 'live' ? accessToken : parsedDevTokenInStorage;

      const url = `/virtual-accounts/total-balance?=${developerId}`;

      const config = {
        headers: {
          Authorization: `Token ${authToken}`,
          'Business-id': developerId,
          Environment: 'live',
        },
      };

      const { data } = await apiInstance.get(url, config);

      return data;
    } catch (err) {
      const error = err as AxiosError<IApiResponseError>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const virtualAccountBalanceGetSlice = createSlice({
  name: 'virtualAccountBalance/get',
  initialState,
  reducers: {
    resetGetVirtualAccountBalance: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVirtualAccountBalanceAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getVirtualAccountBalanceAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetVirtualAccountBalanceResponse;
      })
      .addCase(getVirtualAccountBalanceAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetVirtualAccountBalanceResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetVirtualAccountBalance } =
  virtualAccountBalanceGetSlice.actions;

export default virtualAccountBalanceGetSlice.reducer;
